import { parseTaggedText } from '@splitfiesta/core';

/**
 * Renders a translated legal sentence containing <terms>/<privacy> tags
 * (see auth:legal.* keys) with the tagged spans as links to the static
 * pages. Links open in a new tab so an in-progress signup form is never
 * lost, and anchors inside a checkbox label don't toggle the checkbox
 * (interactive descendants are excluded from label activation).
 */

const TAG_ROUTES: Record<string, string> = {
  terms: '/terms',
  privacy: '/privacy',
};

interface LegalTextProps {
  text: string;
  className?: string;
}

export function LegalText({ text, className }: LegalTextProps) {
  return (
    <span className={className}>
      {parseTaggedText(text).map((segment, index) => {
        const route = segment.tag ? TAG_ROUTES[segment.tag] : undefined;
        return route ? (
          <a
            key={index}
            href={route}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-primary-600 dark:text-primary-400 underline hover:text-primary-700 dark:hover:text-primary-300"
          >
            {segment.text}
          </a>
        ) : (
          <span key={index}>{segment.text}</span>
        );
      })}
    </span>
  );
}
